import TopicNote, { TopicNoteComponentProps } from './TopicNote.container';

export type TopicNoteType = TopicNoteComponentProps;

export default TopicNote;
